export const getInnerHeight = (element: string) => { // Pass in items id or classname, include . or #
    // Get passed in element
    let elm: any = document.querySelector(element);
    // Get styles and remove padding
    //console.log(element);
    let computed = window.getComputedStyle(elm),
        padding = parseInt(computed.paddingTop) + parseInt(computed.paddingBottom);
    return elm.clientHeight - padding;
}

// Gets dimensions of main content area. Area under navigation and to the right of sidemenu/context menu(s)
// * Allows an array of element selectors to be passed in to add to the total height or width define those by passing an object
// * with properties vert (for elements to subtract from vertical height), and horiz (for subtracting horizontal width)
export const getDimensions = (shouldResize: boolean = false, additionalElementsSelectors: {vert?: Array<any>, horiz?: Array<any>} | null = null): {height: number, width: number} => {
    // ? If in the future items need resized dynamically place in here and style them after
    let resizeList: Array<string> = [];
    // ? Getting height/width of static elements such as the window, header, sidemenu, and contextMenu if available
    let windowWidth: number = window.innerWidth;
    let windowHeight: number = window.innerHeight;
    // let header: any = document.querySelector(".top-nav");
    let sidemenu: any = document.querySelector(".sidemenu-wrapper");
    let contextMenu: any = document.querySelector(".context-menu-container");
    // ? Empty array to store custom vertical elements
    //#region Additional Elements Setup
    let additionalElementsVert: Array<any> = [];
    let additionalElementsHoriz: Array<any> = [];
    if(additionalElementsSelectors !== null){
        if(additionalElementsSelectors.vert){ // ? Pushes elements to additionalElementsVert array if it exists in the dom
            additionalElementsSelectors.vert.forEach(selection => {
                let element = document.querySelector(selection);
                element&&additionalElementsVert.push(element);
            });
        }
        if(additionalElementsSelectors.horiz){
            additionalElementsSelectors.horiz.forEach(selection => {
                let element = document.querySelector(selection);
                element&&additionalElementsHoriz.push(element);
            })
        }
    }
    let additionalHeight = 0;
    let additionalWidth = 0;
    additionalElementsVert&&additionalElementsVert.forEach(elem => {additionalHeight += elem.offsetHeight });
    additionalElementsHoriz&&additionalElementsHoriz.forEach(elem => { additionalWidth += elem.offsetHeight });
    //#endregion
    let finalWidth: number = windowWidth - (sidemenu?.offsetWidth || 0) - (contextMenu?.offsetWidth || 0) - additionalWidth;
    //console.log(windowHeight, (header ? header.offsetHeight : 48), additionalHeight);
    let finalHeight: number = windowHeight - additionalHeight - 48; //- (header ? header.offsetHeight : 0)
    //#region Resizing Elements
    if(shouldResize){
        resizeList.forEach(identifier => {
        let el: any = document.querySelector(identifier);
        if(el){
            el.style.height = finalHeight;
        }
    })
    }
    //#endregion
    return({ height: finalHeight, width: finalWidth });
}

export const setHeightToFitContent = (elem: string | Array<string>): void => {
    let elements = elem;
    if(typeof elem === "string"){
        elements = [elem];
    }
    for(let i = 0; i < elements.length; i++){
        let queryString: string = elements[i];
        let elem: HTMLElement | null = document.querySelector(queryString);
        if(elem !== null){
            elem.style.height = "auto";
            elem.style.height = elem?.scrollHeight + "px";
        }else{
            console.error(`Element ${queryString} not found. Unable to set height. (helper.tsx: 555)`);
        }
    }
}
